class AdpLinkController {
  constructor() {
    this.name = 'adpLink';
  }
}

export default AdpLinkController;



// WEBPACK FOOTER //
// ./src/app/components/adpLink/adpLink.controller.js